// 前端页面
const home = [
  {
    path: '/error',
    name: 'home_error',
    component: () => import('@/components/home/error/index.vue')
  },

  {
    path: '/',
    name: 'home',
    component: () => import('@/components/home/main/index.vue')
  },

  {
    path: '/index2',
    component: () => import('@/layouts/home/common.vue'),
    children: [
      {
        path: '/index/patient',
        name: 'index_patient',
        meta: {
          title: '患者版-首页',
          auth: false
        },
        component: () => import('../components/home/index/patient.vue')
      },
    ]
  },

  {
    path: '/index',
    component: () => import('@/layouts/home/common.vue'),
    children: [
      {
        path: '/index/public',
        name: 'index_public',
        meta: {
          title: '公众版-首页',
          auth: false
        },
        component: () => import('../components/home/index/public.vue')
      },
      {
        path: '/index/about',
        name: 'index_patient',
        meta: {
          title: '医院概况',
          auth: false
        },
        component: () => import('../components/home/about/index.vue')
      },
      {
        path: '/index/about/item',
        name: 'index_patient_item',
        meta: {
          title: '医院介绍',
          auth: false
        },
        component: () => import('../components/home/about/item.vue')
      },
      {
        path: '/index/news',
        name: 'index_news',
        meta: {
          title: '新闻公告',
          auth: false
        },
        component: () => import('../components/home/news/index.vue')
      },
      {
        path: '/index/news/:code?!:page?',
        name: 'index_news_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list.vue')
      },
      {
        path: '/index/news/:code?',
        name: 'index_news_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list.vue')
      },

      {
        path: '/index/news2/:code?!:page?',
        name: 'index_news2_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list2.vue')
      },
      {
        path: '/index/news2/:code?',
        name: 'index_news2_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list2.vue')
      },


      {
        path: '/index/news3/:code?!:page?',
        name: 'index_news3_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list3.vue')
      },
      {
        path: '/index/news3/:code?',
        name: 'index_news3_list',
        meta: {
          title: '新闻列表',
          auth: false
        },
        component: () => import('../components/home/news/list3.vue')
      },


      {
        path: '/index/newsitem/:id?',
        name: 'index_news_item',
        meta: {
          title: '新闻详情',
          auth: false
        },
        component: () => import('../components/home/news/item.vue')
      },

      {
        path: '/index/content/:cate?',
        name: 'index_news_content',
        meta: {
          title: '新闻详情',
          auth: false
        },
        component: () => import('../components/home/news/content.vue')
      },

      {
        path: '/index/talent',
        name: 'index_talent_index',
        meta: {
          title: '人才招聘',
          auth: false
        },
        component: () => import('../components/home/talent/index.vue')
      },

      {
        path: '/index/talent/talentrecruitment',
        name: 'index_talent_talentrecruitment',
        meta: {
          title: '人才招聘',
          auth: false
        },
        component: () => import('../components/home/talent/talentrecruitment.vue')
      },



      {
        path: '/index/talent/manpowerItem/:id?',
        name: 'index_talent_manpower_item',
        meta: {
          title: '招聘详情',
          auth: false
        },
        component: () => import('../components/home/talent/manpowerItem.vue')
      },


      {
        path: '/index/nursing',
        name: 'index_nursing_index',
        meta: {
          title: '护理服务',
          auth: false
        },
        component: () => import('../components/home/nursing/index.vue')
      },

      {
        path: '/index/scientific',
        name: 'index_scientific_index',
        meta: {
          title: '科研教育',
          auth: false
        },
        component: () => import('../components/home/scientific/index.vue')
      },

      {
        path: '/index/specialist',
        name: 'index_specialist_index',
        meta: {
          title: '护理科普',
          auth: false
        },
        component: () => import('../components/home/nursing/specialist.vue')
      },

      {
        path: '/index/specialist/:page?',
        name: 'index_specialist_index',
        meta: {
          title: '护理科普',
          auth: false
        },
        component: () => import('../components/home/nursing/specialist.vue')
      },



      {
        path: '/index/speciaitem/:id?',
        name: 'index_specialist_id',
        meta: {
          title: '专家详情',
          auth: false
        },
        component: () => import('../components/home/nursing/speciaitem.vue')
      },
      {
        path: '/index/partygarden',
        name: 'index_partygarden',
        meta: {
          title: '党群园地',
          auth: false
        },
        component: () => import('../components/home/partygarden/index.vue')
      },
      {
        path: '/index/service/navigation',
        name: 'index_service_navigation',
        meta: {
          title: '科室导航',
          auth: false
        },
        component: () => import('../components/home/service/navigation.vue')
      },

      {
        path: '/index/service/navigation/:code?',
        name: 'index_service_navigation_code',
        meta: {
          title: '科室介绍',
          auth: false
        },
        component: () => import('../components/home/service/ks/about.vue')
      },

      {
        path: '/index/service/navigationList/:code?',
        name: 'index_service_navigationList_code',
        meta: {
          title: '科室专家',
          auth: false
        },
        component: () => import('../components/home/service/ks/list.vue')
      },

      {
        path: '/index/service/navigationList/:code?!:page?',
        name: 'index_service_navigationList_code',
        meta: {
          title: '科室专家',
          auth: false
        },
        component: () => import('../components/home/service/ks/list.vue')
      },
      {
        path: '/index/service/navigationItem/:id?',
        name: 'index_service_navigationItem_code',
        meta: {
          title: '专家详情',
          auth: false
        },
        component: () => import('../components/home/service/ks/item.vue')
      },

      {
        path: '/index/service/expertabout',
        name: 'index_service_expertabout',
        meta: {
          title: '专家介绍',
          auth: false
        },
        component: () => import('../components/home/service/expertabout.vue')
      },







    ]
  }
]

const system = [
  {
    path: '/system',
    name: 'system',
    meta: {
      title: '后台系统'
    },
    component: () => import('@/layouts/system/index.vue'),
    children: [
      {
        path: '/system',
        name: 'system_index',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('@/components/system/index/index')
      },
      {
        path: '/system/index',
        name: 'system_index',
        meta: {
          title: '首页',
          auth: false
        },
        component: () => import('@/components/system/index/index')
      },
      {
        path: '/system/user/index',
        name: 'system_user_index',
        meta: {
          title: '个人设置',
          auth: true
        },
        component: () => import('@/components/system/setting/user/index')
      },
      {
        path: '/system/role/index',
        name: 'system_role_index',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/components/system/setting/role/index')
      },
      {
        path: '/system/role/permissions',
        name: 'system_role_permissions',
        meta: {
          title: '权限配置'
        },
        component: () => import('@/components/system/setting/role/permissions')
      },
      {
        path: '/system/role/seting',
        name: 'system_role_seting',
        meta: {
          title: '角色设置'
        },
        component: () => import('@/components/system/setting/role/seting')
      },

      {
        path: '/system/admin/index',
        name: 'system_admin_index',
        meta: {
          title: '账号管理',
          auth: true
        },
        component: () => import('@/components/system/setting/admin/index')
      },
      {
        path: '/system/log/index',
        name: 'system_log_index',
        meta: {
          title: '日志管理',
          auth: true
        },
        component: () => import('@/components/system/setting/log/index')
      },
      {
        path: '/system/sys/index',
        name: 'system_sys_index',
        meta: {
          title: '网站基本管理',
          auth: true
        },
        component: () => import('@/components/system/setting/sys/index')
      },
      {
        path: '/system/menu/sys',
        name: 'system_menu_sys',
        meta: {
          title: '菜单管理',
          auth: true
        },
        component: () => import('@/components/system/setting/menu/sys')
      },
      {
        path: '/system/news/cate',
        name: 'system_news_cate',
        meta: {
          title: '新闻分类',
          auth: true
        },
        component: () => import('@/components/system/news/cate.vue')
      },
      {
        path: '/system/news/add/:id?',
        name: 'system_news_add',
        meta: {
          title: '添加/修改内容',
          auth: true
        },
        component: () => import('@/components/system/news/add.vue')
      },
      {
        path: '/system/news/sh/:id?',
        name: 'system_news_sh',
        meta: {
          title: '审核内容',
          auth: true
        },
        component: () => import('@/components/system/news/sh.vue')
      },


      {
        path: '/system/adver/page',
        name: 'system_adver_page',
        meta: {
          title: '广告类别',
          auth: true
        },
        component: () => import('@/components/system/adver/page.vue')
      },
      {
        path: '/system/adver/index',
        name: 'system_adver_index',
        meta: {
          title: '广告中心',
          auth: true
        },
        component: () => import('@/components/system/adver/index.vue')

      },


      {
        path: '/system/adver/slide/home',
        name: `system_adver_home`,
        meta: {
          auth: true,
          title: '首页轮播图'
        },
        component: () => import('@/components/system/adver/slide/home.vue')
      },
      {
        path: '/system/adver/slide/profile',
        name: `system_adver_profile`,
        meta: {
          auth: true,
          title: '概况幻灯片'
        },
        component: () => import('@/components/system/adver/slide/profile.vue')
      },
      {
        path: '/system/adver/slide/news',
        name: `system_adver_news`,
        meta: {
          auth: true,
          title: '新闻幻灯片'
        },
        component: () => import('@/components/system/adver/slide/news.vue')
      },

      {
        path: '/system/adver/slide/partygarden',
        name: 'system_adver_partygarden',
        meta: {
          title: '党群园地幻灯片',
          auth: true
        },
        component: () => import('@/components/system/adver/slide/partygarden.vue')

      },


      {
        path: '/system/adver/slide/pl',
        name: 'system_adver_pl',
        meta: {
          title: '漂浮广告',
          auth: true
        },
        component: () => import('@/components/system/adver/slide/pl.vue')

      },

      {
        path: '/system/hospital/profile',
        name: 'system_hospital_profile',
        meta: {
          title: '医院简介',
          auth: true
        },
        component: () => import('@/components/system/hospital/profile.vue')
      },
      {
        path: '/system/hospital/culture',
        name: 'system_hospital_culture',
        meta: {
          title: '医院文化',
          auth: true
        },
        component: () => import('@/components/system/hospital/culture.vue')
      },
      {
        path: '/system/hospital/map',
        name: 'system_hospital_map',
        meta: {
          title: '交通位置',
          auth: true
        },
        component: () => import('@/components/system/hospital/map.vue')
      },
      {
        path: '/system/news/news',
        name: 'system_news_index',
        meta: {
          title: '新闻动态',
          auth: true
        },
        component: () => import('@/components/system/news/news.vue')
      },
      {
        path: '/system/news/tender',
        name: 'system_news_tender',
        meta: {
          title: '公告公示',
          auth: true
        },
        component: () => import('@/components/system/news/tender.vue')
      },
      {
        path: '/system/news/jiagegongshi',
        name: 'system_news_jiagegongshi',
        meta: {
          title: '价格公示',
          auth: true
        },
        component: () => import('@/components/system/news/jiagegongshi.vue')
      },
      {
        path: '/system/news/red',
        name: 'system_news_red',
        meta: {
          title: '红十字宣传',
          auth: true
        },
        component: () => import('@/components/system/news/red.vue')
      },
      {
        path: '/system/talent/index',
        name: 'system_talent_index',
        meta: {
          title: '招聘信息',
          auth: false
        },
        component: () => import('../components/system/talent/index.vue')
      },
      {
        path: '/system/talent/down',
        name: 'system_talent_down',
        meta: {
          title: '下载专区',
          auth: false
        },
        component: () => import('../components/system/talent/down.vue')
      },
      {
        path: '/system/talent/discipline',
        name: 'sysmte_talent_discipline',
        meta: {
          title: '规培招录',
          auth: false
        },
        component: () => import('../components/system/talent/discipline.vue')
      },
      {
        path: '/system/talent/recruitment',
        name: 'sysmte_talent_recruitment',
        meta: {
          title: '人才招聘',
          auth: false
        },
        component: () => import('../components/system/talent/recruitment.vue')
      },{
        path: '/system/nursing/teaching',
        name: 'system_nursing_teaching',
        meta: {
          title: '护理教研',
          auth: false
        },
        component: () => import('../components/system/nursing/teaching.vue')
      },
      {
        path: '/system/nursing/specialist',
        name: 'system_nursing_specialist',
        meta: {
          title: '护理科普',
          auth: false
        },
        component: () => import('../components/system/nursing/specialist1.vue')
      },

      {
        path: '/system/nursing/specialist_edit/:id?',
        name: 'system_nursing_specialist_edit',
        meta: {
          title: '护理科普',
          auth: false
        },
        component: () => import('../components/system/nursing/specialist_edit.vue')
      },

      {
        path: '/system/nursing/expert',
        name: 'system_nursing_expert',
        meta: {
          title: '专科护理',
          auth: false
        },
        component: () => import('../components/system/nursing/expert.vue')
      },
      {
        path: '/system/nursing/frontier',
        name: 'system_nursing_frontier',
        meta: {
          title: '护理前沿',
          auth: false
        },
        component: () => import('../components/system/nursing/frontier.vue')
      },
      {
        path: '/system/nursing/angeltalk',
        name: 'system_nursing_angeltalk',
        meta: {
          title: '天使心语',
          auth: false
        },
        component: () => import('../components/system/nursing/angeltalk.vue')
      },



      {
        path: '/system/scientific/notice',
        name: 'system_scientific_notice',
        meta: {
          title: '科教通知',
          auth: false
        },
        component: () => import('../components/system/scientific/notice.vue')
      },

      {
        path: '/system/scientific/cpolicy',
        name: 'system_scientific_cpolicy',
        meta: {
          title: '科研政策',
          auth: false
        },
        component: () => import('../components/system/scientific/cpolicy.vue')
      },

      {
        path: '/system/scientific/ethicscommittee',
        name: 'system_scientific_ethicscommittee',
        meta: {
          title: '伦理委员会',
          auth: false
        },
        component: () => import('../components/system/scientific/ethicscommittee.vue')
      },

      {
        path: '/system/scientific/educationalnotice',
        name: 'system_scientific_educationalnotice',
        meta: {
          title: '教育通知',
          auth: false
        },
        component: () => import('../components/system/scientific/educationalnotice.vue')
      },
      {
        path: '/system/scientific/educationaladvanceme',
        name: 'system_scientific_eeducationaladvanceme',
        meta: {
          title: '教育进修',
          auth: false
        },
        component: () => import('../components/system/scientific/educationaladvanceme.vue')
      },

      {
        path: '/system/scientific/continuingeducation',
        name: 'system_scientific_continuingeducation',
        meta: {
          title: '继续教育',
          auth: false
        },
        component: () => import('../components/system/scientific/continuingeducation.vue')
      },

      {
        path: '/system/partygarden/partybuilding',
        name: 'system_partygarden_partybuilding',
        meta: {
          title: '支部风采',
          auth: false
        },
        component: () => import('../components/system/partygarden/partybuilding.vue')
      },
      {
        path: '/system/partygarden/culturaconstruction',
        name: 'system_partygarden_culturaconstruction',
        meta: {
          title: '文化建设',
          auth: false
        },
        component: () => import('../components/system/partygarden/culturaconstruction.vue')
      },

      {
        path: '/system/partygarden/activity',
        name: 'system_partygarden_activity',
        meta: {
          title: '党建工作',
          auth: false
        },
        component: () => import('../components/system/partygarden/activity.vue')
      },

      {
        path: '/system/partygarden/groupstyle',
        name: 'system_partygarden_groupstyle',
        meta: {
          title: '群团风采',
          auth: false
        },
        component: () => import('../components/system/partygarden/groupstyle.vue')
      },
      {
        path: '/system/service/servicenotice',
        name: 'system_service_servicenotice',
        meta: {
          title: '服务公告',
          auth: false
        },
        component: () => import('../components/system/service/servicenotice.vue')
      },
      {
        path: '/system/service/ks',
        name: 'system_service_ks',
        meta: {
          title: '科室信息',
          auth: false
        },
        component: () => import('../components/system/service/ks.vue')
      },
      {
        path: '/system/service/expert',
        name: 'system_service_expert',
        meta: {
          title: '专家列表',
          auth: false
        },
        component: () => import('../components/system/service/expert.vue')
      },
      {
        path: '/system/service/arrangement',
        name: 'system_service_arrangement',
        meta: {
          title: '门诊安排',
          auth: false
        },
        component: () => import('../components/system/service/arrangement.vue')
      },

      {
        path: '/system/service/register',
        name: 'system_service_register',
        meta: {
          title: '预约挂号',
          auth: false
        },
        component: () => import('../components/system/service/register.vue')
      },

      {
        path: '/system/service/characteristic',
        name: 'system_service_characteristic',
        meta: {
          title: '诊疗特色',
          auth: false
        },
        component: () => import('../components/system/service/characteristic.vue')
      },

      {
        path: '/system/service/health',
        name: 'system_service_health',
        meta: {
          title: '健康科普',
          auth: false
        },
        component: () => import('../components/system/service/health.vue')
      },

      {
        path: '/system/service/physical',
        name: 'system_service_physical',
        meta: {
          title: '体检中心',
          auth: false
        },
        component: () => import('../components/system/service/physical.vue')
      },
      {
        path: '/system/worker/volunteer',
        name: 'system_worker_volunteer',
        meta: {
          title: '“小淞果”志愿者',
          auth: false
        },
        component: () => import('../components/system/worker/volunteer.vue')
      },
			{
			  path: '/system/worker/satisfaction',
			  name: 'system_worker_satisfaction',
			  meta: {
			    title: '满意度调查',
			    auth: false
			  },
			  component: () => import('../components/system/worker/satisfaction.vue')
			},
			{
			  path: '/system/worker/opinions',
			  name: 'system_worker_opinions',
			  meta: {
			    title: '意见及建议',
			    auth: false
			  },
			  component: () => import('../components/system/worker/opinions.vue')
			},
      {
        path: '/system/service/internet',
        name: 'system_service_internet',
        meta: {
          title: '互联网医院',
          auth: false
        },
        component: () => import('../components/system/service/internet.vue')
      },









    ]
  },
  {
    path: '/system/widget/images/index.html',
    name: `images`,
    meta: {
      auth: ['admin-user-user-index'],
      title: '上传图片'
    },
    component: () => import('@/components/system/uploadPictures/widgetImg')
  },
  {
    path: '/system/widget/images/attachment.html',
    name: `attachment`,
    meta: {
      auth: ['admin-user-user-index'],
      title: '上传附件'
    },
    component: () => import('@/components/system/uploadPictures/widgetAttachment')
  },
  {
    path: '/system/login',
    name: 'system_login',
    meta: {
      title: '总用户登录'
    },
    component: () => import('@/components/system/login/index')
  }

]

/**
 * 错误页面
 */

const errorPage = [
  {
    path: '/system/*',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/components/system/error/404')
  }
]

export const systemInRoutes = system

// 重新组织后导出
export default [
  ...home,
  ...system,
  ...errorPage
]



// WEBPACK FOOTER //
// ./src/router/routes.js